export default __webpack_public_path__ + "static/media/shopify-logo.2e6bb5b5.svg";